
  import gql from 'graphql-tag';
  import moment from 'moment';
  import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
  import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
  import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
  import travelTooltips from '~/apollo/queries/product/tooltips/travelTooltips';
  import commonProductMixins from '~/mixins/commonProductMixins.js';
  import productPromotionMixins from '~/mixins/productPromotionMixins.js';
  import travelRegionsQuery from '@/apollo/queries/product/travelRegions'
  import travelScenariosQuery from '@/apollo/queries/product/travelScenarios'
  import productShortcutMixins from "~/mixins/productShortcutMixins.js";
  import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
  import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

  export default {
    name: 'ProductTravelListingPage',
    mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

    apollo: {
      $loadingKey: 'loading',
    travelScenarios: {
        query: gql`
          ${travelScenariosQuery}
          ${productPromotionFragment}
        `,
        prefetch: true,
        variables() {
          let tmpComp;
          tmpComp = undefined;

          let tmpGeoRegion;
          if (this.filter.geoRegionValue.length > 0) {
            tmpGeoRegion = this.filter.geoRegionValue?.map(geo => geo.value) || undefined;
          } else {
            tmpGeoRegion = undefined;
          }

          let tmpLocale;
          tmpLocale = undefined;

          if (this.currentLocale) {
            tmpLocale = this.currentLocale;
          }

          if (this.filter.insCompValue?.length) {
            // console.log(this.filter.insCompValue, 'ins')
            tmpComp = this.filter.insCompValue.map((x) => x.value);
            // console.log(tmpComp)
          }
          // let tmpMobile = false;
          // let tmpPhysio = false;
          // let tmpCar = false;
          // let tmpExtreme = false;
          // let tmpTravel = false;
          // let tmpAny = false;
          const returnObj = {
            insCompCode: tmpComp,
            locale: tmpLocale,
            region_code: tmpGeoRegion,
            // geo_code: tmpGeoCode
            // follow_up_physiotherapy: tmpPhysio,
            // car_rental_excess: tmpCar,
            // extreme_sports_medical: tmpExtreme,
            // loss_of_travel_document: tmpTravel,
          };
          // if (this.filter.geoRegionValue.length > 0) {
          //   returnObj.region_code = tmpGeoRegion;
          // }
          for (const feature of this.filter.featureTypeValue) {
            switch (feature.value) {
              case "1":
              returnObj.mobile_phone_protection = true;
                break;
              case "2":
                returnObj.follow_up_physiotherapy = true;
                break;
              case "3":
                returnObj.car_rental_excess = true;
                break;
              case "4":
                returnObj.extreme_sports_medical = true;
                break;
              case "5":
                returnObj.loss_of_travel_document = true;
                break;
            }
          }
          return returnObj;
        }
      },
      insuranceCompanies: {
        query: insuranceCompaniesQuery,
        prefetch: true,
        variables() {
          return {
            show_travel: true,
          };
        },
        update(data) {
          return data.insuranceCompanies.data.map((item) => {
            const translations = item.attributes.insurance_company_translations.data;
            // console.debug(translations);
            const filteredTranslations = this.getFilteredTranslations(translations);
            return {
              value: item.attributes.code,
              text:
                filteredTranslations[0].attributes.name +
                ' | ' +
                filteredTranslations[1].attributes.name,
            };
          });
        },
      },
      travelRegions: {
        query: travelRegionsQuery,
        prefetch: true,
        update(data) {
          const GeoRegions = [{ value: '-1', text: this.$t('products.any') }];
          const tmpRegion = data.travelRegions?.data.map((item) => {
            return {
              value: item.attributes.travel_region_translations.data[0].attributes.code,
              text: item.attributes.travel_region_translations.data[this.currentLocale === 'en' ? 0 : 1].attributes.description + ' / ' + item.attributes.travel_region_translations.data[this.currentLocale === 'en' ? 1 : 0].attributes.description,
              sorting: item.attributes.sort_order,
              continent: item.attributes.continent,
            }
          })
          return tmpRegion ?
            tmpRegion.sort((a ,b) => {

              if (a.sorting === b.sorting) {
                return 0;
              }

              if (a.sorting === null) {
                return 1;
              }

              if (b.sorting === null) {
                return -1;
              }

              return a.sorting < b.sorting ? -1 : 1
            }) : GeoRegions
        }
      },
      travelTooltips: {
        query: travelTooltips,
        prefetch: true,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.infoTooltip.data);
        },
      },
    },
    data() {
      return {
        loading: 0,
        currentLocale: this.$normalizeLocale(this.$i18n.locale),
        selectionSelected: false,
        filterModalOpen: false,
        filter: {
          insCompValue: [],
          datePeriod: {
            value: [],
            range: 5,
            availableDays: 31,
          },
          geoRegionValue: [{
            value: this.$route.query.geo ? this.$route.query.geo : 'japan',
            text: this.$t("products.travel.td_default_geo"),
            continent: "Asia"
          }],

          adultPremiumValue: {
            value: [
              this.$route.query.adult_premium_from ? parseInt(this.$route.query.adult_premium_from) : 0,
              this.$route.query.adult_premium_to ? parseInt(this.$route.query.adult_premium_to) : 1500,
            ],
            text: this.$t('products.travel.adultPremium'),
          },
          adultPremiumOptions: [
            {
              value: [
                this.$route.query.adult_premium_from ? parseInt(this.$route.query.adult_premium_from) : 0,
                this.$route.query.adult_premium_to ? parseInt(this.$route.query.adult_premium_to) : 1500,
              ],
              text: this.$t('products.travel.adultPremium'),
              label: {'min': this.$t('products.priceMin'), 'max': this.$t('products.priceMax')}
            },
          ],
          adultPremiumSliderRange: [0, 1500],
          adultPremiumSliderStep: 50,

          featureTypeValue: [],
          featureTypeOptions: [
            {
                value: '1',
                text: this.$t('products.travel.td_mobile_protection')
            },
            {
                value: '2',
                text: this.$t('products.travel.td_physio')
            },
            {
                value: '3',
                text: this.$t('products.travel.td_car_rental')
            },
            {
                value: '4',
                text: this.$t('products.travel.td_extreme_sports')
            },
            {
                value: '5',
                text: this.$t('products.travel.td_loss_travel_doc')
            }
          ]
        },
        perPage: 15,
        currentPage: 1,
        // homePlanScenarios: null,
        travelScenarios: null,
        insuranceCompanies: [],
        sortingData: {
          title: this.$t('products.sort'),
          sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'overall_score',
          text: ''
        },
          sortingOptions: [
            { value: 'overall_score', text: this.$t('products.travel.td_overall_score') },
            { value: 'adult_premium', text: this.$t('products.travel.td_sorting_adult_premium') },
            { value: 'medical_emergency_score', text: this.$t('products.travel.td_medical_emergency_score') },
            { value: 'accident_score', text: this.$t('products.travel.td_accident_score') },
            { value: 'inconv_score', text: this.$t('products.travel.td_inconv_score') },
            { value: 'property_score', text: this.$t('products.travel.td_property_score') },
          ],
        },
      };
    },

    computed: {
      modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
      },
      mainQueryLoading() {
        return this.$apollo.queries.travelScenarios.loading;
      },

      resultMessage() {
        if (this.mainQueryLoading) {
          return this.$t('products.travel.td_result').replace('$num', '{ }');
        } else {
          return this.$t('products.travel.td_result').replace('$num', this.rows);
        }
      },

      displayProducts() {
        return this.sortedItem?.map((item) => {
          const featureArray = [];
          if (item.mobile_phone_protection) {
            featureArray.push({
              text: this.$t('products.travel.td_mobile_protection'),
              type: 'mobile'
            })
          }
          if (item.follow_up_physiotherapy) {
            featureArray.push({
              text: this.$t('products.travel.td_physio'),
              type: 'physio'
            })
          };
          if (item.car_rental_excess) {
            featureArray.push({
              text: this.$t('products.travel.td_car_rental'),
              type: 'car_rental'
            })
          };
          if (item.extreme_sports_medical) {
            featureArray.push({
              text: this.$t('products.travel.td_extreme_sports'),
              type: 'extreme_sport'
            })
          };
          if (item.loss_of_travel_document) {
            featureArray.push({
              text: this.$t('products.travel.td_loss_travel_doc'),
              type: 'loss_travel_doc'
            })
          };
          let premiumDay;
          if (this.filter.datePeriod.range < 10) {
            premiumDay = 'premium' + '0' + this.filter.datePeriod.range;
          } else if (this.filter.datePeriod.range >= 10 && this.filter.datePeriod.range <= 31) {
            premiumDay = 'premium' + this.filter.datePeriod.range;
          } else if (this.filter.datePeriod.range > 31) {
            premiumDay = 'premium31';
          }
          return {
            id: item.scenario_code,
            category: this.category,
            scenarioId: item.scenarioID,
            showFiveStarBadge: false,
            showTrending: false,
            showCTA: item.show_cta,
            productLink: this.$extendPath(
              this.$route.path,
              '/' +
              item.scenario_code
              + '?'
              + 'duration='
              + this.filter.datePeriod.range
            ),
            productName: item.plan_name,
            insuranceCompany: {
              name: item.insurer_name_first + ' | ' + item.insurer_name_second,
              code: item.insurer_code,
              logoSrc: item.insurer_logo,
              logoAlt: item.insurer_name_first,
            },
            // userRating: {
            //   score: item.overall_star,
            //   numberOfRatedUser: '0',
            // },
            tenlifeScore: {
              score: parseFloat(this.getScore(item)),
              description: this.$t('products.travel.td_overall_score'),
              toolTipHtml: this.getTooltipContentByKey("tr_overallScore"),
            },
            features: featureArray,
            keyItems: [
              {
                value: this.$formatScore(item.medical_emergency_score) + ' / 10',
                key: this.$t('products.travel.td_medical_emergency_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_medicalEmergencyScore"),
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.$formatScore(item.accident_score) + ' / 10',
                key: this.$t('products.travel.td_accident_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_accidentScore"),
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.$formatScore(item.inconv_score) + ' / 10',
                key: this.$t('products.travel.td_inconv_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_inconvenienceScore"),
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.$formatScore(item.personal_property_score) + ' / 10',
                key: this.$t('products.travel.td_property_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_propertyScore"),
                symbolValue: '',
                originalValue: '',
              },
            ],
            mobileKeyItems: [
              {
                value: this.$formatScore(item.medical_emergency_score) + ' / 10',
                key: this.$t('products.travel.td_medical_emergency_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_medicalEmergencyScore"),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true
              },
              {
                value: this.$formatScore(item.accident_score) + ' / 10',
                key: this.$t('products.travel.td_accident_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_accidentScore"),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true
              },
              {
                value: this.$formatScore(item.inconv_score) + ' / 10',
                key: this.$t('products.travel.td_inconv_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_inconvenienceScore"),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true
              },
              {
                value: this.$formatScore(item.personal_property_score) + ' / 10',
                key: this.$t('products.travel.td_property_score'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey("tr_propertyScore"),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true
              },
            ],
            compactKeyItems: [
              // {
              //   value: item.promotion_price
              //   ? parseInt(item.promotion_price).toLocaleString('en-US')
              //   : item?.premium?.[premiumDay] ? this.$formatPrice(item?.premium?.[premiumDay]) : '',
              // // value: this.$formatPrice(premium),
              // key: this.$t('products.travel.td_adult_premium'),
              // topSubText: 'HKD',
              // toolTipHtml: this.getTooltipContentByKey("tr_adult"),
              // symbolValue: '',
              // originalValue: item.promotion_price? item?.premium?.[premiumDay] ? this.$formatPrice(item?.premium?.[premiumDay]) : '': '',
              // isTextBold: true,
              // },
            ],
            promotion: {
              category:
                item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
              title:
                item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
              ctaButtonLink:
                item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
              ctaButtonText:
                item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
              promotionId: item.product_promotion?.id,
              scenarioId: item.scenarioID,
              hide: item.hide,
              noPopup: item.noPopup,
              lastCall: item.promotion_last_call

            },
            // mainButtonCTA: {
            //   text: item.decoder_cta_text,
            //   link: item.decoder_cta_link,
            // },
            mainButtonCTA: item.main_cta,
            showShortcut: item.shortcut,
            price: {
              // originalPrice: item.promotion_prices[0] ? this.$formatPrice(item.premium) : '',
              // originalPrice: this.$formatPrice(item.premium),
              // originalPrice: this.$formatPrice(premium),
              originalPrice: item.promotion_price ?
              item?.premium?.[premiumDay]? this.$formatPrice(item?.premium?.[premiumDay], 'travel') : ''
              : '',
              discountPrice:
              item.promotion_price ? this.$formatPrice(item?.promotion_price, 'travel'):
              item?.premium?.[premiumDay]? this.$formatPrice(item?.premium?.[premiumDay], 'travel') : '',
              // discountPrice: item.promotion_prices[0]
              //   ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
              //   : this.$formatPrice(item.premium),
              prefix: "HKD",
              postfix: '',
              subText: this.$t('products.travel.td_adult_premium'),
              toolTipHtml: this.getTooltipContentByKey("tr_adult"),
            }
        }
      }
        );
      },

      rows() {
        if (this.simpleItems) {
          return this.simpleItems.length;
        }
        return 0;
      },

      sortedItem() {
        if (this.sortingData.sortValue.value === 'overall_score') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  (Math.round(b.overall_score * 10) / 10) - (Math.round(a.overall_score * 10) / 10) ||
                  aPrem - bPrem ||
                  b.accident_score - a.accident_score ||
                  b.personal_property_score - a.personal_property_score ||
                  b.inconv_score - a.inconv_score ||
                  b.medical_emergency_score - a.medical_emergency_score
                )
              });
          }
        } else if (this.sortingData.sortValue.value === 'medical_emergency_score') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  b.medical_emergency_score - a.medical_emergency_score ||
                  b.overall_score - a.overall_score ||
                  aPrem - bPrem ||
                  b.accident_score - a.accident_score ||
                  b.personal_property_score - a.personal_property_score ||
                  b.inconv_score - a.inconv_score
                )
              });
          }
        } else if (this.sortingData.sortValue.value === 'accident_score') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  b.accident_score - a.accident_score ||
                  b.overall_score - a.overall_score ||
                  aPrem - bPrem ||
                  b.personal_property_score - a.personal_property_score ||
                  b.inconv_score - a.inconv_score ||
                  b.medical_emergency_score - a.medical_emergency_score
                )
              });
          }
        } else if (this.sortingData.sortValue.value === 'inconv_score') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  b.inconv_score - a.inconv_score ||
                  b.overall_score - a.overall_score ||
                  aPrem - bPrem ||
                  b.accident_score - a.accident_score ||
                  b.personal_property_score - a.personal_property_score ||
                  b.medical_emergency_score - a.medical_emergency_score
                )
              });
          }
        } else if (this.sortingData.sortValue.value === 'adult_premium') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  aPrem - bPrem ||
                  b.overall_score - a.overall_score ||
                  b.accident_score - a.accident_score ||
                  b.personal_property_score - a.personal_property_score ||
                  b.inconv_score - a.inconv_score ||
                  b.medical_emergency_score - a.medical_emergency_score
                )
              });
          }
        } else if (this.sortingData.sortValue.value === 'property_score') {
          if (this.simpleItems) {
            return this.simpleItems
              .map((item) => item)
              .sort((a, b) => {
                const premiumDay = this.getPremiumDay();
                const aPrem = a.promotion_price?a.promotion_price:a.premium?.[premiumDay];
                const bPrem = b.promotion_price?b.promotion_price:b.premium?.[premiumDay];
                return (
                  b.personal_property_score - a.personal_property_score ||
                  b.overall_score - a.overall_score ||
                  aPrem - bPrem ||
                  b.accident_score - a.accident_score ||
                  b.inconv_score - a.inconv_score ||
                  b.medical_emergency_score - a.medical_emergency_score
                )
              });
          }
        }

        return null;
      },
      simpleItems() {
        if (this.travelScenarios?.data) {
          const filteredTravelScenarios = this.filterScenariosByPriority(this.travelScenarios.data);
          const premiumDay = this.getPremiumDay();

          // console.debug('filteredTravelScenarios', filteredTravelScenarios);
          if ( premiumDay === null ) return false;
          return filteredTravelScenarios.filter(item => {
            // let premiumDay;
            // if (this.filter.datePeriod.range < 10) {
            //   premiumDay = 'premium' + '0' + this.filter.datePeriod.range;
            // } else if (this.filter.datePeriod.range >= 10 && this.filter.datePeriod.range <= 31) {
            //   premiumDay = 'premium' + this.filter.datePeriod.range;
            // } else if (this.filter.datePeriod.range > 31) {
            //   premiumDay = 'premium31';
            // }
            const isPromotionValid = this.validPromotion(item);
            const isAdultPremiumValid = this.validAdultPremium(item, premiumDay, isPromotionValid);

            if ( isAdultPremiumValid === false ) {
              return false;
            }

            // Filter out FWD insurer when start date is more than 90 days in the future
            if (this.isStartDateMoreThan90DaysInFuture()) {
              const insurerCode = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code;
              if (insurerCode === "FWD") {
                return false;
              }
            }

            return true;
          })
          .map((item) => {
            const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name
            // let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), planName);
            // let decoderCTAText = this.$t('products.purchase_now');

            let promotions = null;
            let promotion = null;

            let promotionPrice = null;
            let promotion_last_call = null;

            let decoderCTALink = '';
            let decoderCTAText = '';
            let hide = Boolean;
            hide = false;
            let noPopup = Boolean;
            noPopup = false;
            let mainCTA = this.getDecoderCTA(item, decoderCTALink);

            // check scenario level promo first , then plan level promotion
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.travel_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
            }

            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              } else {
                if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');

                  mainCTA = this.getDecoderCTA(item, decoderCTALink)
                }
                const discounts = promotion.attributes.DiscountPercentage;
                if (discounts) {
                  // calculate promotion price and avg premium
                  const premiumDay = this.getPremiumDay();

                  const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premiumDay];
                  if(discounts.Year1 !== 0)
                  promotionPrice = originalPrice * (100 - discounts.Year1) / 100;
              }

              const translation = promotion.attributes.product_promotion_translations?.data[0];
              hide = translation?.attributes?.HideBanner;
              noPopup = translation?.attributes?.NoPopup??false;
            }
          }

            const shortcut = this.getProductShortcut(item.attributes);

            const filteredTranslations = this.getFilteredTranslations(item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              // plan
              plan_code: item.attributes.plan_code,
              scenario_code: item.attributes.scenario_code,
              scenarioID: item.id,
              plan_name: planName,
              accident_score: item.attributes.travel_plan.data.attributes.accident_score.toFixed(1),
              inconv_score: item.attributes.travel_plan.data.attributes.inconv_score.toFixed(1),
              medical_emergency_score: item.attributes.travel_plan.data.attributes.medical_emergency_score.toFixed(1),
              personal_property_score: item.attributes.travel_plan.data.attributes.property_score.toFixed(1),
              overall_score: item.attributes.travel_plan.data.attributes.overall_score.toFixed(1),
              saleable: item.attributes.travel_plan.data.attributes.saleable,
              show_cta: item.attributes.show_cta,

              // // feature
              mobile_phone_protection: item.attributes.travel_plan.data.attributes.mobile_phone_protection,
              follow_up_physiotherapy: item.attributes.travel_plan.data.attributes.follow_up_physiotherapy,
              car_rental_excess: item.attributes.travel_plan.data.attributes.car_rental_excess,
              extreme_sports_medical: item.attributes.travel_plan.data.attributes.extreme_sports_medical,
              loss_of_travel_document: item.attributes.travel_plan.data.attributes.loss_of_travel_document,

              // insurer
              insurer_name_first:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
              insurer_name_second:
                filteredTranslations[0].attributes.name,
              insurer_logo:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo.data.attributes.url,

              insurer_code:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,

              // // premium
              premium: item.attributes.travel_premiums.data[0]?.attributes,
              decoder_cta_text: decoderCTAText,
              decoder_cta_link: decoderCTALink,

              product_promotion: promotion,
              promotion_price: promotionPrice,
              promotion_last_call,

              hide,
              noPopup,

              main_cta: mainCTA,
              shortcut,
            }
          })
        }
        return null;
      },
      slug() {
        return 'travel';
      },
      selectedSortingLogic() {
        return this.sortingData.sortValue.value
      },
    },

    created() {
      const filterValuesToWatch = [
        {
          filterValuePath: 'filter.geoRegionValue',
          filterOptionsPath: 'travelRegions',
          queryKey: 'geo[]',
          defaultValue: ['japan'],
          ignoreFix: true,
          type: 'array',
        },
        {
          filterValuePath: 'filter.featureTypeValue',
          filterOptionsPath: 'filter.featureTypeOptions',
          queryKey: 'featuretype[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'array',
        },
        {
          filterValuePath: 'sortingData.sortValue',
          filterOptionsPath: 'sortingData.sortingOptions',
          queryKey: 'sort',
          defaultValue: 'overall_score',
        },
        {
          filterValuePath: 'filter.insCompValue',
          filterOptionsPath: 'insuranceCompanies',
          queryKey: 'ins_comp[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'array',
        },
        {
          filterValuePath: 'filter.datePeriod.value',
          filterOptionsPath: '',
          queryKey: 'date_period[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'arrayDate',
        },
        {
          filterValuePath: 'filter.adultPremiumValue.value[0]',
          queryKey: 'adult_premium_from',
          defaultValue: 0,
          ignoreFix: true,
          type: 'slider',
        },
        {
          filterValuePath: 'filter.adultPremiumValue.value[1]',
          queryKey: 'adult_premium_to',
          defaultValue: 1500,
          ignoreFix: true,
          type: 'slider',
        },
      ];

      this.createFilterWatchers(filterValuesToWatch);
      this.fixFilterValues(filterValuesToWatch);
    },

    mounted() {
      const insurerfilterArrayValueToFix = {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
      };

      this.fixFilterArrayValueDueToQueryString(insurerfilterArrayValueToFix);

      const geofilterArrayValueToFix = {
        filterValuePath: 'filter.geoRegionValue',
        filterOptionsPath: 'travelRegions',
        queryKey: 'geo[]',
      };

      this.fixFilterArrayValueDueToQueryString(geofilterArrayValueToFix);

      const featurefilterArrayValueToFix = {
        filterValuePath: 'filter.featureTypeValue',
        filterOptionsPath: 'filter.featureTypeOptions',
        queryKey: 'featuretype[]',
      };
      // console.log(this.$route.query, 'query')
      this.fixFilterArrayValueDueToQueryString(featurefilterArrayValueToFix);

      const datePeriodfilterArrayValueToFix = {
        filterValuePath: 'filter.datePeriod.value',
        filterOptionsPath: '',
        queryKey: 'date_period[]',
      };
      // console.log(this.$route.query, 'query')
      this.fixFilterArrayValueDueToQueryString(datePeriodfilterArrayValueToFix);
    },

    methods: {
      getDate(date) {
        this.filter.datePeriod.value = date;
        const lastDate = moment(date[1]);
        const firstDate = moment(date[0]);

        if (date.length < 1) return;

        const availableDays = this.filter.datePeriod.availableDays;
        const diff = lastDate.diff(firstDate, 'days') + 1;
        // console.debug('datepicker diff', diff);
        if ( !availableDays ) {
          this.filter.datePeriod.range = diff;
          return diff;
        } else {
          if ( diff <= availableDays ) {
            this.filter.datePeriod.range = diff;
            return diff;
          } else {
            this.filter.datePeriod.range = -1;
            return -1;
          }
        }
      },
      isStartDateMoreThan90DaysInFuture() {
        if (!this.filter.datePeriod.value || this.filter.datePeriod.value.length === 0) {
          return false;
        }

        const firstDate = moment(this.filter.datePeriod.value[0]);
        const today = moment().startOf('day');
        const ninetyDaysFromNow = today.clone().add(90, 'days');

        return firstDate.isAfter(ninetyDaysFromNow);
      },
      parseDate(date) {
        const ydm = date.split('-');
        // console.log(ydm)
        return new Date(ydm[0], ydm[1], ydm[2]);
      },
      getScore(product) {
        return product.overall_score;
      },


      getDecoderCTA(item, promotionCTALink) {
        const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), insurer, planName);
        const showCTA = item.attributes.show_cta;
        const saleable = item.attributes.travel_plan.data.attributes.saleable;
        const productWebsite =
          item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.product_website;

        if (!showCTA) return null;

        if (saleable) {
          return {
            text: this.$t('products.purchase_now'),
            link:
              process.env.SALES_EXTERNAL_URL +
              '/' +
              (this.currentLocale === 'en' ? 'en' : 'tc') +
              '/purchase?id=' +
              item.attributes.scenario_code
          };
        } else if (promotionCTALink) {
          return {
            text: this.$t('products.purchase_now'),
            link: promotionCTALink,
          };
        } else if (productWebsite) {
          return {
            text: this.$t('products.product_website'),
            link: productWebsite,
            type: 'product-website',
          };
        } else {
          return {
            text: '',
            link: decoderCTAWhatsappLink,
          };
        }
      },

      getTooltipContentByKey(mKey) {
        return this.travelTooltips?.Travel?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
      },

      getPremiumDay(){
        let premiumDay;
        if ( this.filter.datePeriod.range < 1 ) return null;
        if (this.filter.datePeriod.range < 10) {
          premiumDay = 'premium' + '0' + this.filter.datePeriod.range;
        } else if (this.filter.datePeriod.range >= 10 && this.filter.datePeriod.range <= 31) {
          premiumDay = 'premium' + this.filter.datePeriod.range;
        } else if (this.filter.datePeriod.range > 31) {
          premiumDay = 'premium31';
        }
        return premiumDay;
      },

      filterScenariosByPriority(scenarios) {
        const priorities = ["-GBA-", "-CHINA-", "-ASIA-", "-AUS-", "-WWexUS-", "-WW-"];
        // use reversed priorities when continents contain both ASIA and other continents in order to prioritize -WWexUS- and -WW- products.
        const reversedPriorities = ["-WWexUS-", "-WW-", "-AUS-", "-ASIA-", "-CHINA-", "-GBA-"];
        const prioritiesWithUSA = ["-WW-"];
        // use prioritiesForAus when geo values only contains ASIA countries and Australia
        const prioritiesForAus = ["-AUS-", "-WWexUS-", "-WW-", "-ASIA-", "-GBA-", "-CHINA-" ];
        const planCodeMap = {};
        const filteredGeoValue = [];
        const filteredContinentArr = [];
        const otherContinentArr = [];
        let isOnlyContainAsia = false;
        let onlyContainAUS = false;
        let containAsiaAndAus = false;
        let containUSA = false;

        this.filter.geoRegionValue.forEach((geo) => {
          filteredGeoValue.push(geo.value);
          filteredContinentArr.push(geo.continent);
        })

        onlyContainAUS = filteredGeoValue.every((geoValue) => geoValue == 'australia');
        isOnlyContainAsia = filteredContinentArr.every((continent) => continent == 'Asia' );

        containUSA = filteredGeoValue.includes('united_states_of_america');

        filteredContinentArr.forEach((item) => {
          if (item !== 'Asia' && item !== 'Oceania') {
            otherContinentArr.push(item);
          }
        })

        if (otherContinentArr.length == 0) {
          if (filteredGeoValue.includes('australia')) {
            containAsiaAndAus = true;
          }
        }

        scenarios.forEach((item) => {
          // eslint-disable-next-line camelcase
          const {plan_code, scenario_code} = item.attributes;
          if (!planCodeMap[plan_code]) {
            planCodeMap[plan_code] = {priorityIndex: Infinity, item: null};
          }
          if (isOnlyContainAsia || onlyContainAUS) {
            for (let i = 0; i < priorities.length; i++) {
              if (scenario_code.includes(priorities[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          } else if (containAsiaAndAus) {
            for (let i = 0; i < prioritiesForAus.length; i++) {
              if (scenario_code.includes(prioritiesForAus[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          } else if (containUSA) {
            for (let i = 0; i < prioritiesWithUSA.length; i++) {
              if (scenario_code.includes(prioritiesWithUSA[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          }
          else {
            for (let i = 0; i < reversedPriorities.length; i++) {
              if (scenario_code.includes(reversedPriorities[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          }
          // eslint-disable-next-line camelcase
          console.debug(`scenario_code "${scenario_code}" does not include the specified text.`);
        });

        const result = [];
        for (const planCode in planCodeMap) {
          if (planCodeMap[planCode].item) {
            result.push(planCodeMap[planCode].item);
          }
        }
        return result;
      },

      changeSelectedFeatures(value) {
        // console.log('value from FilterModal: ', value);
        this.filter.featureTypeValue = value;
      },

      validAdultPremium(item, premiumDay, validPromotion) {
        const itemAdultPremium = validPromotion !== undefined ? validPromotion : item.attributes.travel_premiums.data[0].attributes[premiumDay];
        if (itemAdultPremium === -1) {
          return false;
        } else if ( itemAdultPremium < this.filter.adultPremiumValue.value[0] || itemAdultPremium > this.filter.adultPremiumValue.value[1]) {
          return false;
        }
        return true;
      },

      validPromotion(item) {
        let promotions = null;
        let promotion = null;
        let promotionPrice = null;

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.travel_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
        }

        if(promotions === null) return undefined;
        promotion = this.checkPromotionValid(promotions);

        if (promotion === null) return undefined;

        const discounts = promotion.attributes.DiscountPercentage;
        if (discounts) {
          // calculate promotion price and avg premium
          const premiumDay = this.getPremiumDay();

          const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premiumDay];
          if(discounts.Year1 !== 0) promotionPrice = originalPrice * (100 - discounts.Year1) / 100;

          return promotionPrice;
        }
      },
      onResetFilterPosition() {
        this.$refs.filterModalMobile && this.$refs.filterModalMobile.resetFilterPosition();
      }
    },
    components: {
      QuickGuideWrapper
    }
  };
  